import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class SrPartnerStatsDatePicker extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      showDropdownOptions: false,
    };
  }

  _onClickOption = (e) => {
    this.props.onChange(e.target.dataset.value);
    this.setState({
      showDropdownOptions: false,
    });
  }

  _onToggleDropdownOptions = () => {
    this.setState({
      showDropdownOptions: !this.state.showDropdownOptions,
    });
  }

  render() {
    const showDropdownOptions = this.state.showDropdownOptions;
    const { months, selectedMonthValue } = this.props;
    const selectedMonth = months.find((month) => month.value === selectedMonthValue);

    return (
      <div className='SrPartnerStatsDatePicker'>
        <div className='container'>
          <div
            className='option mainOption'
            onClick={this._onToggleDropdownOptions}
          >
            <span>stats: {selectedMonth && selectedMonth.title}</span>
          </div>
          {showDropdownOptions && (
            <div className='options'>
              {months.map((month) => (
                <div
                  key={month.value}
                  className={classnames('option', {
                    active: selectedMonthValue === month.value,
                  })}
                  data-value={month.value}
                  onClick={this._onClickOption}
                >
                  <span>{month.title}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

SrPartnerStatsDatePicker.displayName = 'SrPartnerStatsDatePicker';

export default SrPartnerStatsDatePicker;
